<template>
    <v-card>
        <your-data-filter v-if="Tab.payload==0"></your-data-filter>
        <benchmark-filter v-if="Tab.payload==1"></benchmark-filter>
        <segment-filter v-if="Tab.payload==2"></segment-filter>
        <cohort-filter v-if="Tab.payload==3"></cohort-filter>
    </v-card>
</template>
<script>
    import { mapState } from 'vuex';
    import YourDataFilter from './YourData/YourDataFilter';
    import BenchmarkFilter from './Benchmark/BenchmarkFilter';
    import SegmentFilter from './Segment/SegmentFilter';
    import CohortFilter from './Cohort/CohortFilter';
    //import '../../../assets/BenchmarkBuilderStyles.css'

    export default {
        components: {
            YourDataFilter,
            BenchmarkFilter,
            SegmentFilter,
            CohortFilter
        },
        data() {
            return {
                Loading: false,
                CategoriesSelected: [],
                selectedTab: 0,
                scrollSettings: {
                    maxScrollbarLength: 160
                }
            }
        },
        computed: mapState({
            Tab: state => state.AppStore.tab
        }),
        methods: {
          
        }
    };
</script>

<style>
    .v-label {
        font-size: 12px;
        font-weight: bold
    }

    .v-list__tile__title {
        font-weight: bold;
        font-size: 12px;
    }

    .fa-chevron-down:before {
        font-size: small;
    }
</style>
